import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import * as fs from 'file-saver';
import { DefaultCompanyLogoBs64 } from '../../validation';

import { DatePipe } from '@angular/common';
import { ClientDataService } from '../client-data.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  myDate = new Date();
  todaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
  CompanyLogoBs64: any;
  constructor(
    private EncrdecrService: EncrdecrService,
    private datePipe: DatePipe,
    private cds: ClientDataService
  ) {
    //////////
  }
  generateClientsExcel(ExcelData: any, ExcelName: string, ExcelHeader: any[]) {
    ////////
    this.CompanyLogoBs64 = ''; //sessionStorage.getItem('pi4ZU2P3M8JE4q7');
    if (this.CompanyLogoBs64 == '') {
      this.CompanyLogoBs64 = ''; //DefaultCompanyLogoBs64;
    }
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(ExcelName, {
      properties: { tabColor: { argb: '4285f4' } },
      views: [{ showGridLines: true }]
    });
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    // let logo = workbook.addImage({
    //   base64: this.CompanyLogoBs64,
    //   extension: 'png',
    // });
    // worksheet.addImage(logo, 'A2:B5');
    let headerRow = worksheet.addRow(ExcelHeader);

    headerRow.font = {
      //name: 'Calibri',
      //size: 16,
      //underline: 'single',
      bold: true,
      color: { argb: 'ffffff' }
    };

    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '6d6e72' }
        //bgColor: { argb: 'ffffff' }
      };

      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    ExcelData.map((arr) => {
      let DataRow = worksheet.addRow(arr);
      //DataRow.eachCell((cell, number) => {
      //  cell.border = {
      //    top: { style: 'thin', color: {argb:'cccccc'}},
      //    left: { style: 'thin', color: {argb:'cccccc'}},
      //    bottom: { style: 'thin', color: {argb:'cccccc'}},
      //    right: { style: 'thin', color: {argb:'cccccc'}}
      //  }
      //});
    });

    worksheet.getColumn(2).width = 15;
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 18;
    worksheet.getColumn(5).width = 35;
    worksheet.getColumn(6).width = 25;
    worksheet.getColumn(7).width = 25;
    worksheet.getColumn(8).width = 25;
    worksheet.getColumn(9).width = 15;
    worksheet.getColumn(10).width = 15;

    worksheet.addRow([]);

    let desclaimer: any[] = ['Disclaimer :'];
    let bottomRow = worksheet.addRow(desclaimer);
    bottomRow.font = { bold: true };

    let desclaimer1: any[] = [
      'This statement is based on the information made available to us by the Asset Management Companies (AMC).'
    ];
    let desclaimer2: any[] = [
      'To that extent, there may be a delay in updating the latest values in this statement in case of delay in receipt of data from the AMCs.'
    ];
    let desclaimer3: any[] = [
      'Hence, the statement from the respective AMC should reflect the exact information for the respective folio. Any discrepancy in the above statement should be reported to us.'
    ];
    let desclaimer4: any[] = [
      'The tax calculations are made based on our interpretation of the Income tax Act. Please contact your Accountant/Tax consultant for the exact calculations. Maturity Date, where displayed is based on available information.'
    ];
    let bottomRow1 = worksheet.addRow(desclaimer1);
    let bottomRow2 = worksheet.addRow(desclaimer2);
    let bottomRow3 = worksheet.addRow(desclaimer3);
    let bottomRow4 = worksheet.addRow(desclaimer4);
    bottomRow1.font = { bold: true };
    bottomRow2.font = { bold: true };
    bottomRow3.font = { bold: true };
    bottomRow4.font = { bold: true };

    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      fs.saveAs(blob, `${ExcelName}.xlsx`);
    });
  }

  generateMultipleExcelSheet(
    ExcelWorkbookName,
    ExcelData: any[],
    ExcelName: any[],
    ExcelHeader: any[]
  ) {
    let workbook = new Workbook();
    let worksheet;
    this.CompanyLogoBs64 = ''; //sessionStorage.getItem('pi4ZU2P3M8JE4q7');
    // if(this.CompanyLogoBs64 == ''){
    //   this.CompanyLogoBs64 = '';//DefaultCompanyLogoBs64;
    // }

    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem('Vbhs@#%LMKIo='); //Flag > C = Corporate | I = IFA
    if (Flag != null && Flag != '' && Flag != undefined) {
      let logo = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
      if (logo != null && logo != '' && logo != undefined) {
        //added by adarsh from here
        if (
          environment.CompayName == 'IFA' &&
          environment.IsOptimoney == false
        ) {
          this.CompanyLogoBs64 =
            'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh=='); //added by adarsh
        } else {
          this.CompanyLogoBs64 = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
        }
        //to here
      } else {
        //Default Logo Image i.e Your Logo
        this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
      }
    }
    //#endregion

    ////////
    for (let i = 0; i < ExcelName.length; i++) {
      worksheet = workbook.addWorksheet(`${ExcelName[i]}`);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      worksheet.addRow([]);
      let logo = workbook.addImage({
        base64: this.CompanyLogoBs64,
        extension: 'png'
      });
      worksheet.addImage(logo, 'A2:B5');
      worksheet.addRow([]);

      let headerRow = worksheet.addRow(ExcelHeader[i]);
      headerRow.font = { bold: true };

      headerRow.eachCell((cell, number) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      ExcelData[i].map((arr) => {
        if (arr[arr.length - 1] === 'headerrow') {
          arr.pop();
          let headerRow1 = worksheet.addRow(arr);
          headerRow1.font = { bold: true };

          headerRow1.eachCell((cell, number) => {
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
          });
        } else if (arr[arr.length - 1] === 'headding') {
          arr.pop();
          let headerRow1 = worksheet.addRow(arr);
          headerRow1.font = { bold: true };
        } else {
          worksheet.addRow(arr);
        }
      });

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);
    });
  }

  generateMultipleTabInOneExcelSheet(
    ExcelWorkbookName,
    ReportMainHeading,
    MainHeading,
    ExcelName: any[],
    ExcelHeader: any[],
    ExcelData: any[]
  ) {
    //var Excel = require('exceljs');
    debugger;
    let workbook = new Workbook();
    let worksheet;

    // this.CompanyLogoBs64 =sessionStorage.getItem('pi4ZU2P3M8JE4q7');
    // if(this.CompanyLogoBs64 == ''){
    //   this.CompanyLogoBs64 = logoFile.logoBase64;
    // }

    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem('Vbhs@#%LMKIo='); //Flag > C = Corporate | I = IFA
    if (Flag != null && Flag != '' && Flag != undefined) {
      let logo = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
      if (logo != null && logo != '' && logo != undefined) {
        //added by adarsh from here
        if (
          environment.CompayName == 'IFA' &&
          environment.IsOptimoney == false
        ) {
          this.CompanyLogoBs64 =
            'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh=='); //added by adarsh
        } else {
          this.CompanyLogoBs64 = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
        }
        //to here
      } else {
        //Default Logo Image i.e Your Logo
        this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
      }
    }
    //#endregion

    ////////
    worksheet = workbook.addWorksheet(ExcelWorkbookName, {
      properties: {
        tabColor: { argb: '4285f4' }
      },
      views: [
        {
          showGridLines: true
        }
      ]
    });

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png'
    });
    if (this.cds.GetCompanyName() === 'Mahindra') {
      worksheet.addImage(logo, 'A2:B3');
    } else {
      worksheet.addImage(logo, 'A2:B5');
    }

    worksheet.addRow([]);
    //////
    let test: any = [ReportMainHeading];
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 };
    worksheet.addRow([]);

    for (let j = 0; j < MainHeading.length; j++) {
      //let  mainheading:any[]=[MainHeading[j]];
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };
    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]);

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      };

      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' }
          //bgColor: { argb: 'ffffff' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      ExcelData[i].map((arr) => {
        if (arr[arr.length - 1] === 'Total') {
          arr.pop();
          let totalRow = worksheet.addRow(arr);

          totalRow.eachCell((cell, number) => {
            (cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' }
              //color: { argb: 'ffffff' }
            }),
              (cell.font = { bold: true });

            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
          });
        } else {
          let DataRow = worksheet.addRow(arr);
          //DataRow.eachCell((cell, number) => {
          //  cell.border = {
          //    top: { style: 'thin', color: {argb:'cccccc'}},
          //    left: { style: 'thin', color: {argb:'cccccc'}},
          //    bottom: { style: 'thin', color: {argb:'cccccc'}},
          //    right: { style: 'thin', color: {argb:'cccccc'}}
          //  }
          //});
        }
      });

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    let desclaimer: any[] = ['Disclaimer :'];
    let bottomRow = worksheet.addRow(desclaimer);
    bottomRow.font = { bold: true };

    let desclaimer1: any[] = [
      'This statement is based on the information made available to us by the Asset Management Companies (AMC).'
    ];
    let desclaimer2: any[] = [
      'To that extent, there may be a delay in updating the latest values in this statement in case of delay in receipt of data from the AMCs.'
    ];
    let desclaimer3: any[] = [
      'Hence, the statement from the respective AMC should reflect the exact information for the respective folio. Any discrepancy in the above statement should be reported to us.'
    ];
    let desclaimer4: any[] = [
      'The tax calculations are made based on our interpretation of the Income tax Act. Please contact your Accountant/Tax consultant for the exact calculations. Maturity Date, where displayed is based on available information.'
    ];
    let bottomRow1 = worksheet.addRow(desclaimer1);
    let bottomRow2 = worksheet.addRow(desclaimer2);
    let bottomRow3 = worksheet.addRow(desclaimer3);
    let bottomRow4 = worksheet.addRow(desclaimer4);
    bottomRow1.font = { bold: true };
    bottomRow2.font = { bold: true };
    bottomRow3.font = { bold: true };
    bottomRow4.font = { bold: true };

    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);
    });
  }
  generateExcel(
    ExcelWorkbookName,
    ReportMainHeading,
    MainHeading,
    ExcelName: any[],
    ExcelHeader: any[],
    ExcelData: any[]
  ) {
    //var Excel = require('exceljs');
    let workbook = new Workbook();
    let worksheet;

    // this.CompanyLogoBs64 =sessionStorage.getItem('pi4ZU2P3M8JE4q7');
    // if(this.CompanyLogoBs64 == ''){
    //   this.CompanyLogoBs64 = logoFile.logoBase64;
    // }

    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem('Vbhs@#%LMKIo='); //Flag > C = Corporate | I = IFA
    if (Flag != null && Flag != '' && Flag != undefined) {
      let logo = sessionStorage.getItem('pi4ZU2P3M8JE4q7').toString();
      if (logo != null && logo != '' && logo != undefined) {
        this.CompanyLogoBs64 = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
      } else {
        //Default Logo Image i.e Your Logo
        this.CompanyLogoBs64 = DefaultCompanyLogoBs64;
      }
    }
    //#endregion

    ////////
    worksheet = workbook.addWorksheet(ExcelWorkbookName, {
      properties: {
        tabColor: { argb: '4285f4' }
      },
      views: [
        {
          showGridLines: true
        }
      ]
    });

    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let logo = workbook.addImage({
      base64: this.CompanyLogoBs64,
      extension: 'png'
    });

    if (this.cds.GetCompanyName() === 'Mahindra') {
      worksheet.addImage(logo, 'A2:B3');
    } else {
      worksheet.addImage(logo, 'A2:B5');
    }
    worksheet.addRow([]);
    //////
    let test: any = [ReportMainHeading];
    let ReportHeading = worksheet.addRow(test);
    ReportHeading.font = { bold: true, size: 14 };
    worksheet.addRow([]);

    for (let j = 0; j < MainHeading.length; j++) {
      //let  mainheading:any[]=[MainHeading[j]];
      let headingRow = worksheet.addRow(MainHeading[j]);
      headingRow.font = { bold: true };
    }

    for (let i = 0; i < ExcelName.length; i++) {
      worksheet.addRow([]);
      let heading: any[] = [ExcelName[i]];
      let headingRow = worksheet.addRow(heading);
      headingRow.font = { bold: true };
      worksheet.addRow([]);
      let headerRow = worksheet.addRow(ExcelHeader[i]);

      headerRow.font = {
        //name: 'Calibri',
        //size: 16,
        //underline: 'single',
        bold: true,
        color: { argb: 'ffffff' }
      };

      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '6d6e72' }
          //bgColor: { argb: 'ffffff' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      ExcelData[i].map((arr) => {
        if (arr[arr.length - 1] === 'Total') {
          arr.pop();
          let totalRow = worksheet.addRow(arr);

          totalRow.eachCell((cell, number) => {
            (cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'e8f0fd' }
              //color: { argb: 'ffffff' }
            }),
              (cell.font = { bold: true });

            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
          });
        } else {
          let DataRow = worksheet.addRow(arr);
          //DataRow.eachCell((cell, number) => {
          //  cell.border = {
          //    top: { style: 'thin', color: {argb:'cccccc'}},
          //    left: { style: 'thin', color: {argb:'cccccc'}},
          //    bottom: { style: 'thin', color: {argb:'cccccc'}},
          //    right: { style: 'thin', color: {argb:'cccccc'}}
          //  }
          //});
        }
      });

      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 15;
      worksheet.getColumn(4).width = 18;
      worksheet.getColumn(5).width = 35;
      worksheet.getColumn(6).width = 25;
      worksheet.getColumn(7).width = 25;
      worksheet.getColumn(8).width = 25;
      worksheet.getColumn(9).width = 15;
      worksheet.getColumn(10).width = 15;

      worksheet.addRow([]);
    }

    let desclaimer: any[] = ['Disclaimer :'];
    // let bottomRow = worksheet.addRow(desclaimer);
    // bottomRow.font = { bold: true };

    //     let  desclaimer1:any[]=['This statement is based on the information made available to us by the Asset Management Companies (AMC).'];
    //     let  desclaimer2:any[]=['To that extent, there may be a delay in updating the latest values in this statement in case of delay in receipt of data from the AMCs.'];
    //     let  desclaimer3:any[]=['Hence, the statement from the respective AMC should reflect the exact information for the respective folio. Any discrepancy in the above statement should be reported to us.'];
    //     let  desclaimer4:any[]=['The tax calculations are made based on our interpretation of the Income tax Act. Please contact your Accountant/Tax consultant for the exact calculations. Maturity Date, where displayed is based on available information.'];
    // let bottomRow1 = worksheet.addRow(desclaimer1);
    // let bottomRow2 = worksheet.addRow(desclaimer2);
    // let bottomRow3 = worksheet.addRow(desclaimer3);
    // let bottomRow4 = worksheet.addRow(desclaimer4);
    // bottomRow1.font = { bold: true };
    // bottomRow2.font = { bold: true };
    // bottomRow3.font = { bold: true };
    // bottomRow4.font = { bold: true };

    workbook.xlsx.writeBuffer().then((ExcelData) => {
      let blob = new Blob([ExcelData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      fs.saveAs(blob, `${ExcelWorkbookName}.xlsx`);
    });
  }
}
